import { Flag, ShoppingCart, Trophy, Timer, Users, BookOpen } from "lucide-react";

export const NAV_ITEMS = [
  { to: "/", label: "Griglia", icon: Flag, testid: "nav-team" },
  { to: "/mercato", label: "Mercato", icon: ShoppingCart, testid: "nav-market" },
  { to: "/classifica", label: "Classifica", icon: Trophy, testid: "nav-leaderboard" },
  { to: "/risultati", label: "Risultati", icon: Timer, testid: "nav-results" },
  { to: "/leghe", label: "Leghe", icon: Users, testid: "nav-leagues" },
  { to: "/regolamento", label: "Regole", icon: BookOpen, testid: "nav-rules" },
];

export const MOBILE_ITEMS = NAV_ITEMS;
